import { FinanceBalanceState, FinanceBalanceType } from '@/api/models/finance'
import { cn } from '@/app/utils'

export const invoiceListDrawerTitle = {
  [FinanceBalanceType.RegularPayment]: 'ЖКУ и дополнительные услуги',
  [FinanceBalanceType.MajorRenovation]: 'Капитальный ремонт',
  [FinanceBalanceType.All]: ''
}

export const ticketMainTypeName = {
  [FinanceBalanceType.RegularPayment]: 'ЖКУ и другие услуги',
  [FinanceBalanceType.MajorRenovation]: 'Капитальный ремонт',
  [FinanceBalanceType.All]: (
    <>
      ЖКУ, доп.услуги <br />и капитальный ремонт
    </>
  )
}

export const ticketAllPaidTypeName = {
  [FinanceBalanceType.RegularPayment]: 'Счета ЖКУ и доп. услуги оплачены',
  [FinanceBalanceType.MajorRenovation]: 'Счета капитального ремонта оплачены',
  [FinanceBalanceType.All]: ''
}

export const ticketNoInvoicesTypeName = {
  [FinanceBalanceType.RegularPayment]: 'Счетов ЖКУ и на доп. услуги нет',
  [FinanceBalanceType.MajorRenovation]: 'Счетов на капитальный ремонт нет',
  [FinanceBalanceType.All]: ''
}

export const ticketTitle = {
  [FinanceBalanceState.NotPaid]: '',
  [FinanceBalanceState.AllPaid]: 'Все счета оплачены',
  [FinanceBalanceState.NoInvoices]: 'Счетов нет'
}

export const ticketButtonText = {
  [FinanceBalanceState.NotPaid]: 'Оплатить',
  [FinanceBalanceState.AllPaid]: 'Обновить',
  [FinanceBalanceState.NoInvoices]: 'Обновить'
}

const ticketRegularPaymentImageProps = {
  src: '/images/balance/summary/ruble.png',
  className: {
    main: cn(
      '-right-[72px] top-0 w-[316px] h-[316px] rotate-3',
      'lg:-right-[46px] lg:w-[240px] lg:h-[240px]'
    ),
    detail: cn(
      '-right-[36px] -top-[42px] w-[297px] h-[297px] rotate-3',
      'lg:-right-[48px] lg:-top-[30px] lg:w-[224px] lg:h-[224px]'
    )
  }
}

export const ticketNotPaidImageProps = {
  [FinanceBalanceType.All]: ticketRegularPaymentImageProps,
  [FinanceBalanceType.RegularPayment]: ticketRegularPaymentImageProps,
  [FinanceBalanceType.MajorRenovation]: {
    src: '/images/balance/summary/key.png',
    className: {
      main: cn(
        '-right-[106px] -top-4 w-[336px] h-[296px] rotate-[-15deg]',
        'lg:-right-[84px] lg:w-[300px] lg:h-[265px]'
      ),
      detail: cn(
        '-right-[74px] -top-[60px] w-[398px] h-[398px] rotate-[-15deg]',
        'lg:-right-[86px] lg:-top-[46px] lg:w-[310px] lg:h-[310px]'
      )
    }
  }
}

export const ticketDefaultImageProps = {
  [FinanceBalanceState.AllPaid]: {
    src: '/images/balance/summary/check.png',
    className: {
      main: cn(
        '-right-[106px] -top-40 w-[336px] h-[296px] -rotate-2',
        'lg:-right-[74px] lg:w-[260px] lg:h-[229px]'
      ),
      detail: cn(
        '-right-[64px] -top-[84px] w-[336px] h-[296px] -rotate-2',
        'lg:-right-[86px] lg:-top-[40px] lg:w-[260px] lg:h-[229px]'
      )
    }
  },
  [FinanceBalanceState.NoInvoices]: {
    src: '/images/balance/summary/house.png',
    className: {
      main: cn(
        '-right-[84px] -top-14 w-[330px] h-[291px] -rotate-3',
        'lg:-right-[64px] lg:-top-8 lg:w-[230px] lg:h-[203px]'
      ),
      detail: cn(
        '-right-[16px] -top-[60px] w-[278px] h-[278px] -rotate-3 -scale-x-100',
        'lg:-right-[64px] lg:-top-8 lg:w-[230px] lg:h-[203px]'
      )
    }
  }
}

const ticketRegularPaymentStyles = {
  root: 'bg-beige-20'
}

export const ticketStyles = {
  [FinanceBalanceType.All]: ticketRegularPaymentStyles,
  [FinanceBalanceType.RegularPayment]: ticketRegularPaymentStyles,
  [FinanceBalanceType.MajorRenovation]: {
    root: 'bg-grey-20'
  }
}

export const ticketBadgeStyles = {
  main: '',
  detail: 'absolute bottom-20 right-20 lg:bottom-16 lg:right-16 md:static'
}
